import { getInstance } from "../../core/axios-gateway";
import type { TTenantPricing, TTenantPricingUpsert } from "../../types/tenant-pricing";

const BASE_PATH = "/api/marketing/tenant-pricing";

export const getTenantPricing = async (tenantId: string) => {
  return getInstance()
    .get<TTenantPricing>(BASE_PATH, { params: { tenantId } })
    .then((res) => res.data);
};

export const createTenantPricing = async (data: TTenantPricingUpsert) => {
  return getInstance()
    .post<TTenantPricing>(BASE_PATH, data)
    .then((res) => res.data);
};

export const updateTenantPricing = async (
  pricingId: string,
  data: TTenantPricingUpsert
) => {
  return getInstance()
    .put<TTenantPricing>(`${BASE_PATH}/${pricingId}`, data)
    .then((res) => res.data);
};
